import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "close-octagon"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-close-octagon',
    templateUrl: './icon-close-octagon.component.html',
    styleUrls: ['./icon-close-octagon.component.scss'],
    standalone: false
})
export class IconCloseOctagonComponent   {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
